import ApiHelper from '../../helpers/apiHelper';
import VoiceIQApiAxiosInstance from '../instances/VoiceIQAPI';
import { store } from '../../app/store';

function assertUsableRouteUserId(userId: unknown, operation: string): string {
  if (userId == null || userId === '' || userId === 'null' || userId === 'undefined') {
    throw new Error(`${operation} skipped — missing userId in route`);
  }
  return String(userId);
}

const getUser = (userId: string, tenantCode: string, AccessToken: string) => {
  const safeUserId = assertUsableRouteUserId(userId, 'getUser');
  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/user/${safeUserId}`,
    method: 'get',
  };

  return VoiceIQApiAxiosInstance.request(config);
};

const getUserTeam = (userId: string, tenantCode: string, AccessToken: string) => {
  const safeUserId = assertUsableRouteUserId(userId, 'getUserTeam');
  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/teams?userId=${safeUserId}`,
    method: 'get',
  };

  return VoiceIQApiAxiosInstance.request(config);
};

const updateUserAvailabilityStatus = (userId: string, tenantCode: string, AccessToken: string, userStatus: any) => {
  const safeUserId = assertUsableRouteUserId(userId, 'updateUserAvailabilityStatus');
  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/userstatus/${safeUserId}/availabilityStatus`,
    method: 'put',
    data: userStatus,
  };

  return VoiceIQApiAxiosInstance.request(config);
};

const getUserWrapupStatus = (userId: string, tenantCode: string, AccessToken: string) => {
  const safeUserId = assertUsableRouteUserId(userId, 'getUserWrapupStatus');
  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/user/${safeUserId}/wrapupstatus`,
    method: 'get',
  };

  return VoiceIQApiAxiosInstance.request(config);
};

const setUserOutboundCallNumberState = (userId: string, tenantCode: string, AccessToken: string, outgoingCallNumberState: any) => {
  const safeUserId = assertUsableRouteUserId(userId, 'setUserOutboundCallNumberState');
  const requestBody = {
    phoneNumberId: outgoingCallNumberState?.phoneNumberId,
    callerIdType: outgoingCallNumberState?.callerIdType,
    userId: safeUserId,
  };

  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/user/${safeUserId}/callerid`,
    method: 'post',
    data: requestBody,
  };

  return VoiceIQApiAxiosInstance.request(config);
};
/*
HTTP POST METHODdo
Route: https://qaapigw.rocketphone.ai/api/v1/user/1b273651-f951-4e08-8d3b-f570f2b444d2/callerId
here 1b273651-.. is the userID
In the requestBody
{
  "PhoneNumberId": "89848d7a-15a2-42cf-90ad-ca1de9882a86",
  "CallerIdType": "Personal"
}
*/

const UserService = { getUser, getUserTeam, updateUserAvailabilityStatus, getUserWrapupStatus, setUserOutboundCallNumberState };

export default UserService;
